import React from 'react'

export const BassTheFish = () => {
    return (
        <svg
            width="70%"
            height="auto"
            viewBox="0 0 389 389"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="194.865" cy="194.582" r="193.199" fill="#232323" />
            <path
                d="M186.028 105.752H218.899C232.657 105.752 243.794 118.999 243.794 135.271V253.9C243.794 270.214 232.621 283.418 218.899 283.418H186.028V105.752Z"
                fill="#F4F9F8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M296.246 149.903C280.907 138.53 262.693 131.459 251.449 131.459V257.713C262.693 257.713 280.907 250.642 296.246 239.183C311.586 227.81 324.195 212.007 324.195 194.586C324.195 177.164 311.622 161.361 296.246 149.903ZM282.451 183.383C278.033 183.383 274.476 178.357 274.476 172.18C274.476 166.004 278.033 160.978 282.451 160.978C286.87 160.978 290.355 166.004 290.355 172.18C290.355 178.357 286.798 183.383 282.451 183.383Z"
                fill="#78FFF0"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M65.5381 237.988V151.221C80.9853 151.221 115.508 170.644 115.508 194.583C115.508 218.522 80.9853 237.945 65.5381 237.945V237.988Z"
                fill="#78FFF0"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M157.177 270.719H120.606V118.439H157.177C168.888 118.439 178.372 131.772 178.372 148.214V240.987C178.372 257.429 168.888 270.762 157.177 270.762V270.719Z"
                fill="#F4F9F8"
            />
        </svg>
    )
}
